module.exports = __webpack_public_path__ + "static/media/gcdef_10013.d27ef556.ico";